/* eslint-disable max-lines */
// Файл сгенерирован скриптом scripts/clusterPinsGrids/generate.mjs
// из дизайна (figma UVg5P0dtgBsmQIbWgSujz1, фрейм «пины» 9186:66738), не редактируйте вручную.
//
// Раскладка пинов раскрытого кластера («монстр-ромашка») для каждого количества офферов.
// Каждый слот — TClusterPin: offset — смещение точки привязки от центра кластера в экранных
// пикселях [x вправо, y вниз]; anchor — какой край балуна привязан к гео-точке (верх по Y всегда);
// zIndex — порядок наложения внутри ромашки. Модель и рендер: constants/clusterPins/types,
// BalloonManager (getShape + styles.css [data-anchor]).
import { EClusterPinAnchor, TClusterPin } from './clusterPins/types';

export const CLUSTER_PINS_GRIDS: Partial<Record<number, readonly TClusterPin[]>> = {
  1: [{ offset: [-1, -23], anchor: EClusterPinAnchor.Center, zIndex: 0 }],
  2: [
    { offset: [0, -34], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [0, -2], anchor: EClusterPinAnchor.Center, zIndex: 1 },
  ],
  3: [
    { offset: [70, -34], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [-70, -34], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-4, -2], anchor: EClusterPinAnchor.Center, zIndex: 2 },
  ],
  4: [
    { offset: [-1.5, -46], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-1.5, 18], anchor: EClusterPinAnchor.Center, zIndex: 1 },
    { offset: [-72.5, -14], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [71.5, -14], anchor: EClusterPinAnchor.Right, zIndex: 3 },
  ],
  5: [
    { offset: [77, -12], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [0, -44], anchor: EClusterPinAnchor.Center, zIndex: 1 },
    { offset: [71, 20], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [-75, -12], anchor: EClusterPinAnchor.Left, zIndex: 3 },
    { offset: [-69, 20], anchor: EClusterPinAnchor.Left, zIndex: 4 },
  ],
  6: [
    { offset: [73, 9], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [-67, 9], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [73, -23], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [0, -53], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [-67, -23], anchor: EClusterPinAnchor.Left, zIndex: 4 },
    { offset: [0, 41], anchor: EClusterPinAnchor.Center, zIndex: 5 },
  ],
  7: [
    { offset: [-104, -30], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-104, 2], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [0, -46], anchor: EClusterPinAnchor.Center, zIndex: 2 },
    { offset: [0, -14], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [0, 18], anchor: EClusterPinAnchor.Center, zIndex: 4 },
    { offset: [104, -30], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [104, 2], anchor: EClusterPinAnchor.Right, zIndex: 6 },
  ],
  8: [
    { offset: [114, -8], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [106, -40], anchor: EClusterPinAnchor.Right, zIndex: 1 },
    { offset: [-1, -48], anchor: EClusterPinAnchor.Center, zIndex: 2 },
    { offset: [0, -12], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [-114, -8], anchor: EClusterPinAnchor.Left, zIndex: 4 },
    { offset: [-106, -40], anchor: EClusterPinAnchor.Left, zIndex: 5 },
    { offset: [-69, 24], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [71, 24], anchor: EClusterPinAnchor.Right, zIndex: 7 },
  ],
  9: [
    { offset: [114, -26], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [0, 20], anchor: EClusterPinAnchor.Center, zIndex: 1 },
    { offset: [106, -58], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [0, -72], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [0, -26], anchor: EClusterPinAnchor.Center, zIndex: 4 },
    { offset: [-114, -26], anchor: EClusterPinAnchor.Left, zIndex: 5 },
    { offset: [-106, -58], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [-106, 6], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [106, 6], anchor: EClusterPinAnchor.Right, zIndex: 8 },
  ],
  10: [
    { offset: [114, -26], anchor: EClusterPinAnchor.Right, zIndex: 0 },
    { offset: [0, 20], anchor: EClusterPinAnchor.Center, zIndex: 1 },
    { offset: [106, -58], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [0, -76], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [0, -12], anchor: EClusterPinAnchor.Center, zIndex: 4 },
    { offset: [0, -44], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [-114, -26], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [-106, -58], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [-106, 6], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [106, 6], anchor: EClusterPinAnchor.Right, zIndex: 9 },
  ],
  11: [
    { offset: [0, 41], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-64, -73], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [66, -73], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [118, -9], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [0, -31], anchor: EClusterPinAnchor.Center, zIndex: 4 },
    { offset: [0, 5], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [106, -41], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [-118, -9], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [-106, -41], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-106, 23], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [106, 23], anchor: EClusterPinAnchor.Right, zIndex: 10 },
  ],
  12: [
    { offset: [-70, 38], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-71, -82], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [70, 38], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [69, -82], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [118, -22], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [0, -40], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [0, -4], anchor: EClusterPinAnchor.Center, zIndex: 6 },
    { offset: [106, -52], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-118, -22], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-105, -52], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-105, 8], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [106, 8], anchor: EClusterPinAnchor.Right, zIndex: 11 },
  ],
  13: [
    { offset: [-71, 58], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-71, -86], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [73, -86], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [106, -14], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [0, 22], anchor: EClusterPinAnchor.Center, zIndex: 4 },
    { offset: [73, 58], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [106, -50], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [0, -50], anchor: EClusterPinAnchor.Center, zIndex: 7 },
    { offset: [0, -14], anchor: EClusterPinAnchor.Center, zIndex: 8 },
    { offset: [-106, -14], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-106, -50], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-106, 22], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [106, 22], anchor: EClusterPinAnchor.Right, zIndex: 12 },
  ],
  14: [
    { offset: [-77, 50], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-77, -78], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [4, -96], anchor: EClusterPinAnchor.Center, zIndex: 2 },
    { offset: [87, -78], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [106, -14], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [4, 64], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [87, 50], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [106, -46], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [0, -32], anchor: EClusterPinAnchor.Center, zIndex: 8 },
    { offset: [0, 4], anchor: EClusterPinAnchor.Center, zIndex: 9 },
    { offset: [-106, -14], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-106, -46], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [-106, 18], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [106, 18], anchor: EClusterPinAnchor.Right, zIndex: 13 },
  ],
  15: [
    { offset: [-77, 58], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-77, -85], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [1, -101], anchor: EClusterPinAnchor.Center, zIndex: 2 },
    { offset: [90, -85], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [111, -14], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [1, 72], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [90, 58], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [111, -50], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [1, -14], anchor: EClusterPinAnchor.Center, zIndex: 8 },
    { offset: [1, -50], anchor: EClusterPinAnchor.Center, zIndex: 9 },
    { offset: [1, 22], anchor: EClusterPinAnchor.Center, zIndex: 10 },
    { offset: [-109, -14], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [-109, -50], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [-109, 22], anchor: EClusterPinAnchor.Left, zIndex: 13 },
    { offset: [111, 22], anchor: EClusterPinAnchor.Right, zIndex: 14 },
  ],
  16: [
    { offset: [-90, 54], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-90, -79], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [90, 54], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [106, -13], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [106, -47], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [90, -81], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [-106, -13], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [-106, -47], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [-106, 21], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [106, 21], anchor: EClusterPinAnchor.Right, zIndex: 9 },
    { offset: [0, -96], anchor: EClusterPinAnchor.Center, zIndex: 10 },
    { offset: [0, 68], anchor: EClusterPinAnchor.Center, zIndex: 11 },
    { offset: [0, 2], anchor: EClusterPinAnchor.Center, zIndex: 12 },
    { offset: [0, 34], anchor: EClusterPinAnchor.Center, zIndex: 13 },
    { offset: [0, -62], anchor: EClusterPinAnchor.Center, zIndex: 14 },
    { offset: [0, -30], anchor: EClusterPinAnchor.Center, zIndex: 15 },
  ],
  17: [
    { offset: [-90, 54], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-90, -79], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [90, 54], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [106, -13], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [106, -47], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [90, -81], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [-106, -13], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [-106, -47], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [-106, 21], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [106, 21], anchor: EClusterPinAnchor.Right, zIndex: 9 },
    { offset: [0, -96], anchor: EClusterPinAnchor.Center, zIndex: 10 },
    { offset: [0, 68], anchor: EClusterPinAnchor.Center, zIndex: 11 },
    { offset: [0, 34], anchor: EClusterPinAnchor.Center, zIndex: 12 },
    { offset: [0, -62], anchor: EClusterPinAnchor.Center, zIndex: 13 },
    { offset: [0, -30], anchor: EClusterPinAnchor.Center, zIndex: 14 },
    { offset: [-69, 2], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [71, 2], anchor: EClusterPinAnchor.Right, zIndex: 16 },
  ],
  18: [
    { offset: [-1, -96], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-90, 54], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-90, -79], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [-1, 68], anchor: EClusterPinAnchor.Center, zIndex: 3 },
    { offset: [90, 54], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [106, -13], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [-1, 34], anchor: EClusterPinAnchor.Center, zIndex: 6 },
    { offset: [106, -47], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [90, -81], anchor: EClusterPinAnchor.Right, zIndex: 8 },
    { offset: [-1, -30], anchor: EClusterPinAnchor.Center, zIndex: 9 },
    { offset: [-106, -13], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-106, -47], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [-106, 21], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [106, 21], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [-69, 2], anchor: EClusterPinAnchor.Left, zIndex: 14 },
    { offset: [71, 2], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [71, -63], anchor: EClusterPinAnchor.Right, zIndex: 16 },
    { offset: [-69, -63], anchor: EClusterPinAnchor.Left, zIndex: 17 },
  ],
  19: [
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 2 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 6 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 7 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 9 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 12 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 13 },
    { offset: [-68, 71], anchor: EClusterPinAnchor.Left, zIndex: 14 },
    { offset: [72, 71], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [-2, -99], anchor: EClusterPinAnchor.Center, zIndex: 16 },
    { offset: [0, 31], anchor: EClusterPinAnchor.Center, zIndex: 17 },
    { offset: [0, -33], anchor: EClusterPinAnchor.Center, zIndex: 18 },
  ],
  20: [
    { offset: [0, -99], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [-1, 31], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [70, -34], anchor: EClusterPinAnchor.Right, zIndex: 8 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 12 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 13 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 16 },
    { offset: [-68, 71], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [72, 71], anchor: EClusterPinAnchor.Right, zIndex: 18 },
    { offset: [-70, -34], anchor: EClusterPinAnchor.Left, zIndex: 19 },
  ],
  21: [
    { offset: [0, -99], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [-1, 31], anchor: EClusterPinAnchor.Center, zIndex: 5 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [70, -33], anchor: EClusterPinAnchor.Right, zIndex: 8 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 12 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 13 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 16 },
    { offset: [-68, 71], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [72, 71], anchor: EClusterPinAnchor.Right, zIndex: 18 },
    { offset: [-70, -34], anchor: EClusterPinAnchor.Left, zIndex: 19 },
    { offset: [-1, -33], anchor: EClusterPinAnchor.Center, zIndex: 20 },
  ],
  22: [
    { offset: [0, -99], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [70, -33], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [-70, 71], anchor: EClusterPinAnchor.Left, zIndex: 16 },
    { offset: [70, 71], anchor: EClusterPinAnchor.Right, zIndex: 17 },
    { offset: [-70, -34], anchor: EClusterPinAnchor.Left, zIndex: 18 },
    { offset: [97, 31], anchor: EClusterPinAnchor.Right, zIndex: 19 },
    { offset: [-88, 31], anchor: EClusterPinAnchor.Left, zIndex: 20 },
    { offset: [1, 31], anchor: EClusterPinAnchor.Center, zIndex: 21 },
  ],
  23: [
    { offset: [0, -99], anchor: EClusterPinAnchor.Center, zIndex: 0 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [-70, 71], anchor: EClusterPinAnchor.Left, zIndex: 16 },
    { offset: [70, 71], anchor: EClusterPinAnchor.Right, zIndex: 17 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 18 },
    { offset: [-1, -33], anchor: EClusterPinAnchor.Center, zIndex: 19 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 20 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 21 },
    { offset: [-1, 31], anchor: EClusterPinAnchor.Center, zIndex: 22 },
  ],
  24: [
    { offset: [-70, -100], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [70, -100], anchor: EClusterPinAnchor.Right, zIndex: 1 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 3 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 8 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 12 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 13 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [-70, -66], anchor: EClusterPinAnchor.Left, zIndex: 16 },
    { offset: [-70, 71], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [70, 71], anchor: EClusterPinAnchor.Right, zIndex: 18 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 19 },
    { offset: [-1, -33], anchor: EClusterPinAnchor.Center, zIndex: 20 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 21 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 22 },
    { offset: [-1, 31], anchor: EClusterPinAnchor.Center, zIndex: 23 },
  ],
  25: [
    { offset: [-70, -100], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [70, -100], anchor: EClusterPinAnchor.Right, zIndex: 1 },
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 3 },
    { offset: [-70, 69], anchor: EClusterPinAnchor.Left, zIndex: 4 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 8 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 9 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 11 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [-70, -1], anchor: EClusterPinAnchor.Left, zIndex: 14 },
    { offset: [70, -1], anchor: EClusterPinAnchor.Right, zIndex: 15 },
    { offset: [70, -66], anchor: EClusterPinAnchor.Right, zIndex: 16 },
    { offset: [-70, -64], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [70, 69], anchor: EClusterPinAnchor.Right, zIndex: 18 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 19 },
    { offset: [0, -33], anchor: EClusterPinAnchor.Center, zIndex: 20 },
    { offset: [0, 80], anchor: EClusterPinAnchor.Center, zIndex: 21 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 22 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 23 },
    { offset: [0, 38], anchor: EClusterPinAnchor.Center, zIndex: 24 },
  ],
  26: [
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-76, 69], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [-76, -1], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [74, -1], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [74, -67], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [-76, -67], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [74, 69], anchor: EClusterPinAnchor.Right, zIndex: 16 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [0, -33], anchor: EClusterPinAnchor.Center, zIndex: 18 },
    { offset: [0, 80], anchor: EClusterPinAnchor.Center, zIndex: 19 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 20 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 21 },
    { offset: [0, 38], anchor: EClusterPinAnchor.Center, zIndex: 22 },
    { offset: [74, -100], anchor: EClusterPinAnchor.Right, zIndex: 23 },
    { offset: [-76, -100], anchor: EClusterPinAnchor.Left, zIndex: 24 },
    { offset: [0, -110], anchor: EClusterPinAnchor.Center, zIndex: 25 },
  ],
  27: [
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-76, 69], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [-76, -1], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [74, -1], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [74, -67], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [-76, -67], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [74, 69], anchor: EClusterPinAnchor.Right, zIndex: 16 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [0, -33], anchor: EClusterPinAnchor.Center, zIndex: 18 },
    { offset: [0, 80], anchor: EClusterPinAnchor.Center, zIndex: 19 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 20 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 21 },
    { offset: [0, 38], anchor: EClusterPinAnchor.Center, zIndex: 22 },
    { offset: [74, -100], anchor: EClusterPinAnchor.Right, zIndex: 23 },
    { offset: [-76, -100], anchor: EClusterPinAnchor.Left, zIndex: 24 },
    { offset: [0, -110], anchor: EClusterPinAnchor.Center, zIndex: 25 },
    { offset: [0, -67], anchor: EClusterPinAnchor.Center, zIndex: 26 },
  ],
  28: [
    { offset: [-92, 48], anchor: EClusterPinAnchor.Left, zIndex: 0 },
    { offset: [-92, -80], anchor: EClusterPinAnchor.Left, zIndex: 1 },
    { offset: [-76, 69], anchor: EClusterPinAnchor.Left, zIndex: 2 },
    { offset: [91, 46], anchor: EClusterPinAnchor.Right, zIndex: 3 },
    { offset: [107, -18], anchor: EClusterPinAnchor.Right, zIndex: 4 },
    { offset: [107, -50], anchor: EClusterPinAnchor.Right, zIndex: 5 },
    { offset: [91, -82], anchor: EClusterPinAnchor.Right, zIndex: 6 },
    { offset: [95, -33], anchor: EClusterPinAnchor.Right, zIndex: 7 },
    { offset: [-108, -16], anchor: EClusterPinAnchor.Left, zIndex: 8 },
    { offset: [-108, -48], anchor: EClusterPinAnchor.Left, zIndex: 9 },
    { offset: [-108, 16], anchor: EClusterPinAnchor.Left, zIndex: 10 },
    { offset: [107, 14], anchor: EClusterPinAnchor.Right, zIndex: 11 },
    { offset: [-76, -1], anchor: EClusterPinAnchor.Left, zIndex: 12 },
    { offset: [74, -1], anchor: EClusterPinAnchor.Right, zIndex: 13 },
    { offset: [74, -67], anchor: EClusterPinAnchor.Right, zIndex: 14 },
    { offset: [-76, -67], anchor: EClusterPinAnchor.Left, zIndex: 15 },
    { offset: [74, 69], anchor: EClusterPinAnchor.Right, zIndex: 16 },
    { offset: [-84, -34], anchor: EClusterPinAnchor.Left, zIndex: 17 },
    { offset: [0, -33], anchor: EClusterPinAnchor.Center, zIndex: 18 },
    { offset: [0, 80], anchor: EClusterPinAnchor.Center, zIndex: 19 },
    { offset: [95, 31], anchor: EClusterPinAnchor.Right, zIndex: 20 },
    { offset: [-84, 31], anchor: EClusterPinAnchor.Left, zIndex: 21 },
    { offset: [0, 38], anchor: EClusterPinAnchor.Center, zIndex: 22 },
    { offset: [74, -100], anchor: EClusterPinAnchor.Right, zIndex: 23 },
    { offset: [-76, -100], anchor: EClusterPinAnchor.Left, zIndex: 24 },
    { offset: [0, -110], anchor: EClusterPinAnchor.Center, zIndex: 25 },
    { offset: [0, -67], anchor: EClusterPinAnchor.Center, zIndex: 26 },
    { offset: [0, 1], anchor: EClusterPinAnchor.Center, zIndex: 27 },
  ],
};

export const CLUSTER_PINS_GRID_MAX_COUNT = 28;
